import { LegalLayout } from '@/components/legal/LegalLayout';

export default function Privacy() {
  return (
    <LegalLayout
      title="Privacy Policy"
      description="How Yaw CTV (Yaw Media Group) collects, uses, and protects information submitted through yawctv.com."
      path="/privacy"
      updated="June 18, 2026"
    >
      <p>
        This Privacy Policy explains how Yaw CTV, the advertising brand operated by Yaw Media Group
        ("we," "us," or "our"), handles information collected through{' '}
        <a href="https://www.yawctv.com">yawctv.com</a> (the "Site"). We are a digital marketing
        agency serving government agencies and businesses.
      </p>

      <h2>Information we collect</h2>
      <p>
        <strong>Information you provide.</strong> When you submit our contact or campaign forms, we
        collect the details you choose to share — such as your name, email address, phone number,
        organization, role, campaign goals, budget range, timeline, and any message you include.
      </p>
      <p>
        <strong>Information collected automatically.</strong> Like most websites, our hosting and
        infrastructure providers may log standard technical data (such as IP address, browser type,
        and pages viewed) to operate and secure the Site. We do not use the Site to knowingly
        collect sensitive personal information.
      </p>

      <h2>How we use information</h2>
      <ul>
        <li>Respond to your inquiry and prepare a tailored proposal or strategy.</li>
        <li>Provide, maintain, and improve our services and the Site.</li>
        <li>Communicate with you about your request.</li>
        <li>Comply with legal obligations and protect against misuse.</li>
      </ul>
      <p>We do not sell your personal information.</p>

      <h2>How we share information</h2>
      <p>
        We share information only with service providers that help us operate the Site and respond to
        leads — for example, our cloud hosting and database provider and our email delivery
        provider — and only as needed to perform those services. We may also disclose information
        when required by law or to protect our rights.
      </p>

      <h2>Data retention</h2>
      <p>
        We retain submitted information for as long as necessary to respond to your inquiry, provide
        services, and meet legal, accounting, or reporting requirements, after which it is deleted or
        anonymized.
      </p>

      <h2>Security</h2>
      <p>
        We use reasonable technical and organizational measures — including access controls and
        encryption in transit — to protect information. No method of transmission or storage is 100%
        secure, so we cannot guarantee absolute security.
      </p>

      <h2>Your choices and rights</h2>
      <p>
        You may request access to, correction of, or deletion of the personal information you have
        submitted by emailing <a href="mailto:ads@yawctv.com">ads@yawctv.com</a>. Depending on where
        you live, you may have additional rights under laws such as the CCPA or GDPR; we will honor
        applicable requests.
      </p>

      <h2>Children's privacy</h2>
      <p>
        The Site is intended for businesses and government organizations and is not directed to
        children under 13. We do not knowingly collect personal information from children.
      </p>

      <h2>Third-party links</h2>
      <p>
        The Site may link to third-party websites. We are not responsible for the privacy practices
        of those sites and encourage you to review their policies.
      </p>

      <h2>Changes to this policy</h2>
      <p>
        We may update this Privacy Policy from time to time. Changes are effective when posted, and we
        will update the "Last updated" date above.
      </p>

      <h2>Contact us</h2>
      <p>
        Yaw Media Group (Yaw CTV) — Orlando, Florida, USA. Questions about this policy? Email{' '}
        <a href="mailto:ads@yawctv.com">ads@yawctv.com</a>.
      </p>

      <p className="text-xs">
        This page is provided for general information and does not constitute legal advice. Please
        have it reviewed by qualified counsel before relying on it.
      </p>
    </LegalLayout>
  );
}
